import { z } from "zod";

export interface CustomerTeamListModel {
    readonly id: string;
    readonly name: string;
    readonly members: { name: string; id: string }[];
}

export type CustomerTeam = (CustomerTeamListModel & { listUpdated: Date });

export const customerTeamCreateUpdateModelSchemaFactory = (customerTeams: CustomerTeam[]) => {
    const membersInOtherTeams = customerTeams.flatMap((t) => t.members.map((m) => m.id));
    return z.object({
        name: z.string({ required_error: "Name is required" }),
        memberIds: z.array(z.string().refine((id) => membersInOtherTeams.indexOf(id) === -1, { message: "User can only be a member of one team" }))
    }).required();
};

export type CustomerTeamCreateUpdateModel = Required<z.infer<ReturnType<typeof customerTeamCreateUpdateModelSchemaFactory>>>;
